import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-itfacilitycloser',
  templateUrl: './itfacilitycloser.component.html',
  styleUrls: ['./itfacilitycloser.component.scss']
})
export class ITfacilitycloserComponent implements OnInit {
public ITcloserData:any=[];
public employeeId:any=[];
public Itcloserdata1:any=[];
  constructor(public appservice:AppService,public toastr:ToastrService,public router:Router) { }
getemployeeif(){
  this.appservice.getTable("api/Transaction/GetItfacility_empid").subscribe((res:any)=>{
  this.employeeId=JSON.parse(res).record;

  })
}
Onselectempolyee() {
  const empId = this.ITcloserData.employeeid;
  if (!empId) {
    console.warn("Employee ID is missing");
    return;
  }

  this.appservice.getTable(`api/Transaction/GetItfacility_closer?empid=${empId}`)
    .subscribe({
      next: (res: any) => {
        // If your API already returns JSON, no need to parse
        const data = JSON.parse(res).record[0];
        
        if (!data) {
          console.warn("No employee data found");
          return;
        }

        // Populate ITcloserData
        this.ITcloserData = {
          ...this.ITcloserData,
          OD_EmployeeID: data.IR_EmployeeId,
          Fullname: data.IR_Fullname,
          Username: data.IR_ADUserName,
          Mailid: data.IR_ADMailId,
          Designation: data.IR_Designation,
          grade: data.IR_Grade,
          department: data.IR_Department,
          AssertType: data.IR_AssertType,
          DriveAccess: data.IR_NacDriver_Access,
          Dongle: data.IR_Dongle_SimCard,
          MSimcard: data.IR_Mobilesim,
          Biometric: data.IR_Biometric_card,
          DoorAccess: data.IR_DoorAccess,
          Other:data.IR_Other
        };

        console.log("Employee selected:", this.ITcloserData.Fullname);
      },
      error: (err) => {
        console.error("Error fetching employee details:", err);
      }
    });
}
// Onselectempolyee(){
//   this.appservice.getTable("api/Transaction/GetItfacility_closer?empid="+this.ITcloserData.employeeid).subscribe((res:any)=>{
//     this.Itcloserdata1=JSON.parse(res).record?.[0];
//     //console.log(this.Itcloserdata1);
//     if(this.Itcloserdata1 ){
//     let emp=this.Itcloserdata1?.[0];
//     this.ITcloserData.OD_EmployeeID=emp.IR_EmployeeId;
//       this.ITcloserData.Fullname=emp.IR_Fullname;
//       console.log(emp.IR_Fullname);
//       this.ITcloserData.Username=emp.IR_ADUserName;
//       this.ITcloserData.Mailid=emp.IR_ADMailId;
//       this.ITcloserData.Designation=emp.IR_Designation;
//       this.ITcloserData.grade=emp.IR_Grade;
//       this.ITcloserData.department=emp.IR_Department;
//       this.ITcloserData.AssertType= emp.IR_AssertType;
//       this.ITcloserData.DriveAccess=emp.IR_NacDriver_Access;
//       this.ITcloserData.Dongle=emp.IR_Dongle_SimCard;
//       this.ITcloserData.MSimcard=emp.IR_Mobilesim;
//       this.ITcloserData.Biometric=emp.IR_Biometric_card;
//       this.ITcloserData.DoorAccess=emp.IR_DoorAccess;
//      // this.ITcloserData.status=emp.IR_Status;
//   }
//   })
// }
back(){
  this.appservice.goback();
}
onApprove(){
  this.ITcloserData.status='Approved';
  this.ITcloserData.approvedby=this.appservice.username;
   this.appservice.getTable("api/Transaction/update_itfacilitycloser?empid="+this.ITcloserData.OD_EmployeeID+"&status="+this.ITcloserData.status+"&username="+this.ITcloserData.approvedby).subscribe((res:any)=>{
    this.toastr.success("Approved successfully!");
    this.appservice.getcheckerITfacilitygrid();
    this.getemployeeif();
   });
  //this.appservice.checkeritfacilityedit='';
  //this.router.navigate(['/home/checkerreview'])
  this.appservice.goback();
}
onDecline(){
  this.ITcloserData.status='Rejected';
  this.ITcloserData.approvedby=this.appservice.username;
    this.appservice.getTable("api/Transaction/update_itfacilitycloser?empid="+this.ITcloserData.OD_EmployeeID+"&status="+this.ITcloserData.status+"&username="+this.ITcloserData.approvedby).subscribe((res:any)=>{
  this.toastr.success("Rejected successfully!");
    this.appservice.getcheckerITfacilitygrid();
    this.getemployeeif();
    });
    this.appservice.goback();
  //this.router.navigate(['/home/checkerreview'])
}
  ngOnInit(): void {
    this.getemployeeif();
  }

}
